import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { OverlayPanel } from 'primeng/overlaypanel';
import { Subscription } from 'rxjs';
import { StudentAccess } from 'src/app/constants/constants';
import { CommonService } from 'src/app/services/common.service';
import { ParentChildrenService } from 'src/app/services/parent-children.service';

interface modifiedSvg {
  svgName: string;
  subSvgs: subSvg[];
  imgPath: string;
  isHovered: boolean;
  isRouteActive: boolean;
  routePath: string[];
  isExpanded: boolean;
  roles: string[];
  isAcademic: boolean;
  isTestPrep: boolean;
  isPackage: boolean;
  default: boolean;
}

interface subSvg {
  subSvgName: string;
  isRouteActive: boolean;
  routePath: string;
  imgPath: string;
}

interface genSvg {
  svgName: string;
  routePath: string[];
  subSvgs: subSvg[];
  roles: string[];
  imgPath: string;
  isAcademic: boolean;
  isTestPrep: boolean;
  isPackage: boolean;
  default: boolean;
}

@Component({
  selector: 'app-common-side-navbar',
  templateUrl: './common-side-navbar.component.html',
  styleUrls: ['./common-side-navbar.component.scss'],
})
export class CommonSideNavbarComponent implements OnInit, OnDestroy {
  // ** variable holding the sideNavbar display status
  showSideNavbar: boolean = false;
  showMobileNavbar: boolean = false;
  fullName: string = '';

  isScrolled = false;

  private userNameSubscription: Subscription;
  // ** variable holding the current route
  currentRoute: string = '';
  // ** boolean representing the expanded or shrinked view
  isFullView: boolean = true;

  // ** path for assets (icons)
  svgPath: string = 'assets/images/side-navbar';
  childrenLoading: boolean = false;
  children: any[] = [];
  selectedChild: number = 0;
  childrenSubscription: Subscription;
  childrenLoadingSubscription: Subscription;
  selectedChildSubscription: Subscription;

  // ** general svg array
  // ** add the routes here in 'routePath' option instead of the HTML
  // ** (two routePaths available
  // ** 'after svgName'- mainoption
  // ** 'in subSvgs'- subOption
  svgs: genSvg[] = [
    {
      svgName: 'Dashboard',
      routePath: ['/new-dashboard'],
      subSvgs: [],
      roles: ['1', '2', '3', '4'],
      imgPath: `assets/images/side-navbar/dashboard-hover.svg`,
      isAcademic: true,
      isTestPrep: true,
      isPackage: true,
      default: true,
    },
    {
      svgName: 'Schedules',
      routePath: ['/schedules'],
      subSvgs: [],
      roles: ['3', '4'],
      imgPath: `assets/images/side-navbar/classes-hover.svg`,
      isAcademic: true,
      isTestPrep: true,
      isPackage: false,
      default: false,
    },
    {
      // svgName: 'Academic Coaching',
      svgName: 'Study Material',
      routePath: ['/academic-coaching'],
      subSvgs: [],
      roles: [],
      imgPath: `assets/images/side-navbar/academic coaching-hover.svg`,
      isAcademic: true,
      isTestPrep: false,
      isPackage: false,
      default: false,
    },
    // {
    //   svgName: 'Testprep',
    //   routePath: ['/student-learning', '/practice-test'],
    //   subSvgs: [
    //     {
    //       subSvgName: 'Learning Modules',
    //       routePath: '/student-learning',
    //       isRouteActive: false,
    //       imgPath: 'assets/images/side-navbar/learning modules.svg',
    //     },
    //     {
    //       subSvgName: 'Practice Tests',
    //       routePath: '/practice-test',
    //       isRouteActive: false,
    //       imgPath: 'assets/images/side-navbar/practice tests.svg',
    //     },
    //   ],
    //   roles: ['3', '4'],
    //   imgPath: `assets/images/side-navbar/testprep-hover.svg`,
    //   isAcademic: false,
    //   isTestPrep: true,
    // },
    {
      svgName: 'Learning Modules',
      routePath: ['/student-learning'],
      subSvgs: [],
      roles: ['3', '4'],
      imgPath: `assets/images/side-navbar/learning-modules.svg`,
      isAcademic: true,
      isTestPrep: true,
      isPackage: true,
      default: false,
    },
    {
      svgName: 'Practice Tests',
      routePath: ['/practice-test'],
      subSvgs: [],
      roles: ['3', '4'],
      imgPath: `assets/images/side-navbar/practice-tests.svg`,
      isAcademic: false,
      isTestPrep: true,
      isPackage: true,
      default: true,
    },
    {
      svgName: 'Workshops',
      routePath: ['/workshops/list'],
      subSvgs: [],
      roles: ['3', '4'],
      imgPath: 'assets/images/side-navbar/workshop.svg',
      isAcademic: false,
      isTestPrep: true,
      isPackage: false,
      default: false,
    },
    {
      svgName: 'Test Scores',
      routePath: ['/view-results'],
      subSvgs: [],
      roles: [''],
      imgPath: `assets/images/side-navbar/testprep-hover.svg`,
      isAcademic: false,
      isTestPrep: false,
      isPackage: false,
      default: false,
    },
    {
      svgName: 'Payments',
      routePath: ['/student-payments'],
      subSvgs: [],
      roles: ['1', '2', '3', '4'],
      imgPath: `assets/images/side-navbar/credit-card-hover.svg`,
      isAcademic: false,
      isTestPrep: false,
      isPackage: false,
      default: true,
    },
  ];

  // ** modififed svgs array
  modifiedSvgs: modifiedSvg[] = [];

  role = localStorage.getItem('roleId') || '';
  studentAccess: StudentAccess = {
    academic: localStorage['haveAcademicCoaching']
      ? JSON.parse(localStorage['haveAcademicCoaching'])
      : false,
    testPrep: localStorage['haveTestPrep']
      ? JSON.parse(localStorage['haveTestPrep'])
      : false,
    package: localStorage['havePackage']
      ? JSON.parse(localStorage['havePackage'])
      : false,
  };
  roleSubscription: Subscription;
  studentAccessSubscription: Subscription;
  mobileExpandedSvgs: subSvg[] = [];

  constructor(
    private router: Router,
    private commonService: CommonService,
    private parentChildrenService: ParentChildrenService
  ) {
    this.roleSubscription = this.commonService
      .getUserRole()
      .subscribe((role: string) => {
        this.role = role;
        console.log(this.role);
      });
    this.studentAccessSubscription = this.commonService
      .getStudentAccess()
      .subscribe((studentAccess: StudentAccess) => {
        this.studentAccess = studentAccess;
      });
    // ** router subscription
    this.router.events.subscribe((event: any) => {
      // this.showSideNavbar = window.location.pathname !== '/login';
      if (
        this.currentRoute.includes('/student-learning') ||
        this.currentRoute.includes('workshops/view')
      )
        this.isFullView = false;
      if (event instanceof NavigationEnd) {
        // ** setting present/current route to the variable current route.
        this.currentRoute = event.url;
        const role = localStorage.getItem('roleId');
        console.log(event);
        this.showSideNavbar =
          this.currentRoute !== '/login' &&
          this.currentRoute !== '/' &&
          this.currentRoute !== '/stripe-payment' &&
          !this.currentRoute.includes('/stripe-payment/pay') &&
          !this.currentRoute.includes('/student-test') &&
          (role === '3' || role === '4') &&
          window.innerWidth > 540;
        this.showMobileNavbar = role === '3' || role === '4';
        if (this.currentRoute === '/login' || this.currentRoute === '/') {
          this.modifiedSvgs = [];
          this.makeModifiedSvgs();
          this.isFullView = true;
        }
        console.log(this.showSideNavbar);
      }
    });

    this.childrenLoadingSubscription = this.parentChildrenService
      .getChildrenLoading()
      .subscribe((childrenLoading: boolean) => {
        this.childrenLoading = childrenLoading;
      });
    this.userNameSubscription = this.commonService
      .getFullName()
      .subscribe((name) => {
        this.fullName = name;
      });

    this.childrenSubscription = this.parentChildrenService
      .getChildren()
      .subscribe((children: any) => {
        this.children = children;
      });

    this.selectedChildSubscription = this.parentChildrenService
      .getSelectedChildren()
      .subscribe((selectedChild: string) => {
        this.selectedChild = parseInt(selectedChild);
      });
  }

  ngOnInit(): void {
    // ** triggering methog for making array of modifiedSvgs (refer the above interface (modifiedSvg))
    this.makeModifiedSvgs();
  }
  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isScrolled = window.scrollY > 0;
  }
  onContentScroll(event: any) {
    const scrollTop = event.target.scrollTop;
    this.isScrolled = scrollTop > 0;
  }

  // ** Method to create modifiedSvgs array ('modifiedSvgs' array is being used for looping in *ngFor)
  makeModifiedSvgs() {
    this.svgs.forEach((svg: genSvg, svgindex: number) => {
      let svgObj: modifiedSvg = {
        svgName: svg.svgName === 'Testprep' ? 'Test Prep' : svg.svgName,
        subSvgs: [],
        // svgPath: `${this.svgPath}/${svg.svgName.toLowerCase()}.svg`,
        // svgHoverPath: `${this.svgPath}/${svg.svgName.toLowerCase()}-hover.svg`,
        imgPath: svg.imgPath,
        isHovered: false,
        isRouteActive: false,
        routePath: svg.routePath,
        isExpanded: false,
        roles: svg.roles,
        isAcademic: svg.isAcademic,
        isTestPrep: svg.isTestPrep,
        isPackage: svg.isPackage,
        default: svg.default,
      };
      svg.subSvgs.forEach((subSvg: subSvg, subSvgIndex: number) => {
        svgObj.subSvgs.push(subSvg);
      });
      this.modifiedSvgs.push(svgObj);
    });
    // ** Setting active class on-init w.r.t to current route (isRouteActive, isExpanded to true)
    window.setTimeout(() => {
      console.log(this.currentRoute);
      this.modifiedSvgs.forEach((modifiedSvg, modifiedSvgIndex) => {
        // if (
        //   modifiedSvg.routePath === this.currentRoute &&
        //   modifiedSvg.routePath !== ''
        // ) {
        //   modifiedSvg.isRouteActive = true;
        // } else {
        if (modifiedSvg.subSvgs.length > 0) {
          modifiedSvg.subSvgs.forEach((subSvg, subSvgIndex) => {
            if (subSvg.routePath === this.currentRoute) {
              subSvg.isRouteActive = true;
              modifiedSvg.isRouteActive = true;
              modifiedSvg.isExpanded = true;
            }
          });
        }
        // }
      });
    }, 100);
  }

  // ** Method for changing the hover status (isHovered) w.r.t the hover state (mouseover, mouseout)
  changeSvg(svgIndex: number, isHovered: boolean) {
    alert("I'm triggered");
    let modifiedSvg: modifiedSvg = this.modifiedSvgs[svgIndex];
    modifiedSvg.isHovered = isHovered && !modifiedSvg.isRouteActive;
  }

  // ** Method for changing the paths for icons dynamically.
  getSvgPath(svgIndex: number): string {
    let modifiedSvg: modifiedSvg = this.modifiedSvgs[svgIndex];
    let path: string =
      modifiedSvg.isHovered ||
      modifiedSvg.isRouteActive ||
      modifiedSvg.isExpanded
        ? modifiedSvg.imgPath
        : modifiedSvg.imgPath;
    return path;
  }

  // TODO: Deprecated Method - Used for getting the routerLink path dynamically for main options.
  // TODO: Should remove it permanently.
  getRouteLink(index: number): string {
    console.log(index);
    // let route = ""
    let svgName: string = this.svgs[index].svgName.toLowerCase();
    svgName =
      svgName !== ''
        ? svgName === 'dashboard'
          ? 'dashboard'
          : svgName === 'classes'
          ? 'view-classes'
          : svgName === 'coaching'
          ? 'coaching'
          : 'not-found'
        : 'not-found';
    // } else if (svgName === 'testprep') {
    //   svgName = 'student-learning';
    // }
    let option: string = '/' + svgName;
    let modifiedSvg: modifiedSvg = this.modifiedSvgs[index];
    // if (modifiedSvg.subSvgs.length > 0) {
    if (this.currentRoute === option) {
      // this.modifiedSvgs.forEach((modifiedSvg, modifiedSvgIndex) => {
      //   modifiedSvg.isRouteActive = false;
      //   modifiedSvg.subSvgs.forEach((subSvg, subSvgIndex) => {
      //     subSvg.isRouteActive = false;
      //   });
      // });
      modifiedSvg.isRouteActive = true;
    } else {
      // if (modifiedSvg.subSvgs.length > 0) {
      //   modifiedSvg.subSvgs.forEach((subSvg: subSvg, subSvgIndex: number) => {
      //     if (subSvg.isRouteActive) {
      //       modifiedSvg.isRouteActive = true;
      //       console.log(modifiedSvg);
      //     } else {
      //       // modifiedSvg.isRouteActive = modifiedSvg.isRouteActive;
      //     }
      //   });
      // } else {
      //   // modifiedSvg.isRouteActive = false;
      // }
    }
    // console.log(modifiedSvg);
    // }
    // modifiedSvg.isRouteActive =
    //   this.currentRoute === option
    //     ? true
    //     : modifiedSvg.subSvgs.forEach((subSvg: subSvg, subSvgIndex: number) => {
    //         subSvg.isRouteActive ? true : false;
    //       });
    // modifiedSvg.isExpanded = this.currentRoute === option ? true : false;
    return option;
  }

  // TODO: Deprecated Method - Used for getting the routerLink path dynamically for sub options.
  // TODO: Should remove it permanently.
  getSubRouteLink(index: number, subIndex: number): string {
    let svgName: string = this.svgs[index].svgName.toLowerCase();
    let subSvgs = this.svgs[index].subSvgs;
    let subSvgName: string = '';
    subSvgName =
      subIndex >= 0 ? subSvgs[subIndex].subSvgName.toLowerCase() : '';
    svgName =
      subSvgName !== ''
        ? subSvgName === 'learning modules'
          ? 'student-learning'
          : subSvgName === 'practice tests'
          ? 'practice'
          : 'not-found'
        : 'not-found';
    let option: string = '/' + svgName;
    let modifiedSvg: modifiedSvg = this.modifiedSvgs[index];
    // modifiedSvg.isRouteActive = this.currentRoute === option ? true : false;
    // subSvgs[subIndex].isRouteActive =
    //   this.currentRoute === option ? true : false;
    // if (this.currentRoute === option) {
    //   modifiedSvg.isExpanded = true;
    // }
    // modifiedSvg.isExpanded = this.currentRoute === option ? true : false;
    return option;
  }

  // ** Method for changing the option expanded state (If there are subOptions)
  // ** And at the same time it is also used for
  // ** removing or maintain the existing style class by changing the status of
  // ** 'isRouteClass' or 'isExpanded' for particular 'main' option.
  expandOption(svgIndex: number) {
    // this.modifiedSvgs.forEach((modifiedSvg, modifiedSvgIndex) => {
    //   modifiedSvg.isExpanded = false;
    // });
    let modifiedSvg = this.modifiedSvgs[svgIndex];
    if (modifiedSvg.subSvgs.length <= 0) {
      this.modifiedSvgs.forEach((modifiedSvg, modifiedSvgIndex) => {
        modifiedSvg.isRouteActive = false;
        modifiedSvg.subSvgs.forEach((subSvg, subSvgIndex) => {
          subSvg.isRouteActive = false;
        });
      });
    }
    if (modifiedSvg.subSvgs.length > 0) {
      modifiedSvg.isExpanded = !modifiedSvg.isExpanded;
    }
    if (modifiedSvg.subSvgs.length === 0) {
      if (this.currentRoute === modifiedSvg.routePath[0]) {
        window.location.reload();
      }
      this.router.navigateByUrl(modifiedSvg.routePath[0]);
      modifiedSvg.isRouteActive = !modifiedSvg.isRouteActive;
    }
  }

  expandOptionMobile(svgIndex: number, overlayPanel: OverlayPanel, event: any) {
    // this.modifiedSvgs.forEach((modifiedSvg, modifiedSvgIndex) => {
    //   modifiedSvg.isExpanded = false;
    // });
    let modifiedSvg = this.modifiedSvgs[svgIndex];
    if (modifiedSvg.subSvgs.length <= 0) {
      this.modifiedSvgs.forEach((modifiedSvg, modifiedSvgIndex) => {
        modifiedSvg.isRouteActive = false;
        modifiedSvg.subSvgs.forEach((subSvg, subSvgIndex) => {
          subSvg.isRouteActive = false;
        });
      });
    }
    if (modifiedSvg.subSvgs.length > 0) {
      // modifiedSvg.isExpanded = !modifiedSvg.isExpanded;
      this.mobileExpandedSvgs = modifiedSvg.subSvgs;
      overlayPanel.toggle(event);
    }
    if (modifiedSvg.subSvgs.length === 0) {
      this.router.navigateByUrl(modifiedSvg.routePath[0]);
      modifiedSvg.isRouteActive = !modifiedSvg.isRouteActive;
    }
  }

  // ** Method for changing the option expanded state (If there are subOptions)
  // ** And at the same time it is also used for
  // ** removing or maintain the existing style class by changing the status of
  // ** 'isRouteClass' or 'isExpanded' for particular 'sub' option.
  subNavigation(index: number, subIndex: number) {
    let modifiedSvg = this.modifiedSvgs[index];
    let submodifiedSvg = modifiedSvg.subSvgs[subIndex];
    // if (modifiedSvg.subSvgs.length <= 0) {
    this.modifiedSvgs.forEach((modifiedSvg, modifiedSvgIndex) => {
      modifiedSvg.isRouteActive = false;
      modifiedSvg.subSvgs.forEach((subSvg, subSvgIndex) => {
        subSvg.isRouteActive = false;
      });
    });
    // }
    if (submodifiedSvg.routePath != '') {
      if (submodifiedSvg.routePath === '/student-learning')
        this.isFullView = false;
      if (
        submodifiedSvg.routePath === '/student-learning' &&
        this.currentRoute.includes('/student-learning')
      ) {
        // console.log('window refresh please');
        location.reload();
      }
      this.router.navigateByUrl(submodifiedSvg.routePath);
      modifiedSvg.isRouteActive = !modifiedSvg.isRouteActive;
      submodifiedSvg.isRouteActive = !submodifiedSvg.isRouteActive;
      this.modifiedSvgs.forEach((modifiedSvg, modifiedSvgIndex) => {
        modifiedSvg.subSvgs.forEach((subSvg, subSvgIndex) => {
          if (submodifiedSvg.routePath === subSvg.routePath) {
            subSvg.isRouteActive = true;
            modifiedSvg.isRouteActive = true;
          }
        });
      });
    }
  }

  toggleOverlay(overlayPanel: OverlayPanel, event: any) {
    overlayPanel.toggle(event);
  }

  testPrepClicked: boolean = false;
  testPrepClickedMethod() {
    this.testPrepClicked = true;
  }

  logout() {
    // localStorage.clear();
    // this.parentChildrenService.setChildren([]);
    // this.parentChildrenService.setChildrenLoading(false);
    // this.parentChildrenService.setSelectedChildren('0');
    // this.router.navigate(['']);
    this.commonService.logout();
  }

  changeView() {
    this.isFullView = !this.isFullView;
    this.commonService.setSideBarCollapsedState(!this.isFullView);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    const role = localStorage.getItem('roleId');
    console.log(event);
    this.showSideNavbar =
      this.currentRoute !== '/login' &&
      this.currentRoute !== '/' &&
      this.currentRoute !== '/stripe-payment' &&
      !this.currentRoute.includes('/stripe-payment/pay') &&
      !this.currentRoute.includes('/student-test') &&
      (role === '3' || role === '4') &&
      window.innerWidth > 540;
    this.showMobileNavbar = role === '3' || role === '4';
  }

  setchildren() {
    console.log(this.selectedChild);
    localStorage.setItem(
      'selectedChild',
      JSON.stringify(this.children[this.selectedChild])
    );
    this.parentChildrenService.setSelectedChildren(
      JSON.stringify(this.selectedChild)
    );
    localStorage.setItem('childIndex', this.selectedChild.toString());
    console.log(this.children);
    this.commonService.setStudentAccess({
      academic:
        !!this.children[this.selectedChild]['haveAcademicCoaching'] || false,
      testPrep: !!this.children[this.selectedChild]['haveTestPrep'] || false,
      package: !!this.children[this.selectedChild]['havePackage'] || false,
    });
  }

  subMobileNavigation(path: string): void {
    if (
      path === '/student-learning' &&
      this.currentRoute.includes('/student-learning')
    ) {
      // console.log('window refresh please');
      location.reload();
    } else {
      this.router.navigateByUrl(path);
    }
  }

  ngOnDestroy(): void {
    this.roleSubscription.unsubscribe();
    this.userNameSubscription.unsubscribe();
  }
}
